const form = document.getElementById('contact-form');
// console.error(form)
// console.log(typeof form !== "undefined" && form !== null)

if (typeof form !== "undefined" && form !== null) {
    const submit_button = form.querySelector('button[type="submit"]');

    form.addEventListener('submit', event => {
        event.preventDefault();
        let is_valid = true;
        const form_elements = form.querySelectorAll('input, textarea');
        form_elements.forEach(element => {
            if (!element.checkValidity()) {
                is_valid = false;

            }
        })
        if (is_valid) {
            submit_button.setAttribute('disabled', true);
            form.reset();
            form.classList.remove('show-errors');
            form.focus();
        } else {
            form.classList.add('show-errors')
        }
    });
}